import { Component, OnInit } from '@angular/core'
import { timer } from 'rxjs'
import { take } from 'rxjs/operators'
import { ToastData } from './toast-config'
import { ToastRef } from './toast-ref'

@Component({
    selector: 'keying-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    standalone: false
})
export class KeyingToastComponent implements OnInit {
  toastTime = 120000
  showToast = true

  constructor(readonly data: ToastData, readonly ref: ToastRef) {}

  ngOnInit() {
    if (this.data.time) {
      this.toastTime = this.data.time
      this.oberserableTimer()
    }
  }

  oberserableTimer() {
    const source = timer(this.toastTime)
    source.pipe(take(1)).subscribe(() => {
      this.close()
    })
  }

  get typeIcon(): string {
    const icons: Record<string, string> = {
      info: 'notifications',
      warning: 'warning_amber',
      error: 'error_outline',
      success: 'check_circle_outline',
    }
    return icons[this.data.type] ?? 'notifications'
  }

  close() {
    this.data.onDismiss?.()
    this.ref.close()
  }

  action() {
    this.data.onAction?.()
  }
}
